import * as Redirect from "./actions/redirect/index";
import * as Client from "./client/Client";
import * as Oauth from "./actions/Oauth";
import * as Modal from "./actions/Modal";
import * as Message from "./actions/Message";
import * as shared from "./utils/share";
import * as Camera from "./actions/Camera";
import * as Pos from "./actions/Pos";
import * as Share from "./actions/Share";
import * as Session from "./actions/Session";
import * as SaveBar from "./actions/SaveBar";
import * as FullScreen from "./actions/FullScreen";
import * as Loading from "./actions/Loading";
import * as ResourcePicker from "./actions/ResourcePicker";
import * as UnstableResourcePicker from "./actions/UnstablePicker";
import { getHost, getSessionToken, getAppstate } from "./utils/share";
import { ADMIN_SECTION } from "./enum/ActionEnum";
import * as AppState from "./actions/State";
export default Client;
export { Modal, Oauth, Message, Redirect, shared, Camera, Session, Pos, Share, Loading, SaveBar, AppState, FullScreen, ResourcePicker, UnstableResourcePicker, ADMIN_SECTION };
export var shareUtil = {
  getHost: getHost,
  getAppstate: getAppstate,
  getSessionToken: getSessionToken
};